import { render, staticRenderFns } from "./item-order-detail.vue?vue&type=template&id=bcc3c9c2&"
import script from "./item-order-detail.vue?vue&type=script&lang=js&"
export * from "./item-order-detail.vue?vue&type=script&lang=js&"
import style0 from "./item-order-detail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports